export default {
      id: "receipt-long-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.6f915410.svg#receipt-long",
      toString: function () {
        return this.url;
      }
    }